import { SearchWhiteListKeys, SearchBlackListKeys } from './search/search.state';
import { AssetsWhiteListKeys } from './assets/assets.state';
import { TableColumnsWhiteListKeys } from './table-columns/table-columns.state';
import { HistoryWhiteListKeys } from './history/history.state';
import { CurrentUserWhiteListKeys } from './user/user.state';

//list of the keys that will be saved
export const CombinedWhiteListKeys = [
  ...SearchWhiteListKeys,
  ...AssetsWhiteListKeys,
  ...TableColumnsWhiteListKeys,
  ...HistoryWhiteListKeys,
  ...CurrentUserWhiteListKeys
];

//list of the keys that will be excluded from the saved
export const CombinedBlackListKeys = [...SearchBlackListKeys];
